import { Box, Typography, useTheme } from "@mui/material";
import React, { useEffect } from "react";
import { useGetLeaveCounts } from "../../../Production/OrderArchive/Hook";
import DisplayLeaveItem from "./DisplayLeaveItem";
import LeaveResultBox from "../../../OrganizationDefinitions/CreateUserAccount/Components/TabItems/Leave/components/LeaveResultBox";
import useDeviceType from "../../../global/Hooks/useDeviceType";

function PersonLeave() {
  const theme = useTheme().palette.mode;
  const deviceType= useDeviceType()
  const userInfo = JSON.parse(localStorage.getItem("userInfo"));
  const { data } = useGetLeaveCounts(userInfo?.personId);
  useEffect(() => {
  }, [data]);

  return (
    <Box
      sx={{
        background: theme === "dark" ? "#262D39" : "#FFF",
        boxShadow: "0px 1px 2px 0px rgba(0, 0, 0, 0.14)",
        borderRadius: "1rem",
        padding: "1rem",
        marginY: "1rem",
      }}
    >
      <Typography> آمارمرخصی</Typography>
      <Box
        sx={{
          display: "flex",
          flexWrap: "wrap",
          alignItems: "center",
          justifyContent: "space-between",
        }}
      >
        <Box
          sx={{
            display: "flex",
            alignItems: "center",
            margin: "0.5rem 0",
            width: {md: "49%", xs: "100%"},
            flexDirection: deviceType === "mobile"? "column" : "row",
          }}
        >
          <Typography color={"#1E6AFD"} sx={{ margin: "0 0.5rem" }}>
            {" "}
            استفاده شده در ماه :
          </Typography>
          <DisplayLeaveItem
            day={data?.string_UsedDailyThisMonth}
            hours={data?.string_UsedHourlyThisMonth}
          />
        </Box>
        <Box
          sx={{
            display: "flex",
            alignItems: "center",
            justifyContent: "end",
            margin: "0.5rem 0",
            width: {md: "49%", xs: "100%"},
            flexDirection: deviceType === "mobile"? "column" : "row",
          }}
        >
          <Typography color={"#1E6AFD"} sx={{ margin: "0 0.5rem" }}>
            {" "}
            استفاده شده کل :
          </Typography>
          <DisplayLeaveItem
            day={data?.string_TotalUsedDaily}
            hours={data?.string_TotalUsedHourly}
          />
        </Box>
      </Box>

      <Box
        sx={{
          display: "flex",
          flexWrap: "wrap",
          alignItems: "center",
          justifyContent: "space-between",

        }}
      >
        <Box
          sx={{
            display: "flex",
            alignItems: "center",
            margin: "0.5rem 0",
            width: {md: "49%", xs: "100%"},
            flexDirection: deviceType === "mobile"? "column" : "row",
          }}
        >
          <Typography color={"#1E6AFD"} sx={{ margin: "0 0.5rem" }}>
            مجموع باقیمانده کل:
          </Typography>

          <Box
            sx={{
              display: "flex",
              alignItems: "center",
              bgcolor: theme === "dark" ? "rgb(22, 27, 37)" : "#F7FBFF",
              flex: 1,
              border: theme === "dark" ? "1px solid rgb(22, 27, 37)"  : "1px solid #E6F1FF",
              borderRadius: "4px",
              padding: "4px",
            }}
          >
            <LeaveResultBox>{data?.string_TotalRemainingDaily}</LeaveResultBox>{" "}
            یا
            <LeaveResultBox>{data?.string_TotalRemainingHourly}</LeaveResultBox>
          </Box>
        </Box>
        <Box
          sx={{
            display: "flex",
            alignItems: "center",
            margin: "0.5rem 0",
           width: {md: "49%", xs: "100%"},
            justifyContent: "end",
            flexDirection: deviceType === "mobile"? "column" : "row",
          }}
        >
          <Typography color={"#1E6AFD"} sx={{ margin: "0 0.5rem" }}>
            مجموع استحقاقی:
          </Typography>
          <Box
            sx={{
              display: "flex",
              alignItems: "center",
              bgcolor: theme === "dark" ? "rgb(22, 27, 37)" : "#F7FBFF",
              border: theme === "dark" ? "1px solid rgb(22, 27, 37)"  : "1px solid #E6F1FF",
              borderRadius: "4px",
              padding: "4px",
              flex: 1,
            }}
          >
            <LeaveResultBox>{data?.string_TotalHaveDaily}</LeaveResultBox> یا
            <LeaveResultBox>{data?.string_TotalHaveHourly}</LeaveResultBox>
          </Box>
        </Box>
      </Box>
    </Box>
  );
}

export default PersonLeave;
